import styled from "@emotion/styled";
import Page from 'components/layout/Page';
import { useState, useEffect } from 'react';

import PaymentHistory from "./PaymentHistory";
import SubsManagement from "./SubsManage";
import { useGetSubscribeDetail } from "hooks/api";

import { subscribeDataAtom, payhistoryAtom } from "components/pages/MyTap/MyTapAtom";
import { useAtom } from 'jotai';

const Elem:React.FC<any> = () => {
  const [tab, setTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [ , setSubscribeData ] = useAtom(subscribeDataAtom);
  const [ , setPayhistory ] = useAtom(payhistoryAtom);

  const { data } = useGetSubscribeDetail();
  
  const handleTabClick = (index:number) => {
    setTab(index);
    setActiveTab(index)
  };

  const handleGoToHome = () => {
    window.location.href="/home"
  };

  const handleSubscribeData = () => {
    setSubscribeData({
      payDay: data?.payDay || "",
      estimatedAmount : data?.estimatedAmount || "",
      bank: data?.payData?.bank || 0,
      companyId: data?.payData?.companyId || "",
      cardNumber :data?.payData?.cardNumber || "",
      subsData: data?.subsData?.data ||"",
      isDiscount: data?.isDiscount || ""
    });
    
    setPayhistory(
      data?.allPayhistory
    )
  }

  useEffect(() => {
    handleSubscribeData();
  }, [data])


  return (
    <Container>
      <TapContainer className="tab-list">
        <BigText
          className={activeTab === 0? "tab active" : "tab"}
          //@ts-ignore
          isSelected={tab===0}
          onClick={() => handleTabClick(0)}
        >
          구독관리
        </BigText>
        <TapLine></TapLine>
        <BigText
          className={activeTab === 1 ? "tab active" : "tab"}
          //@ts-ignore
          isSelected={tab === 1}
          onClick={() => handleTabClick(1)}
        >
          결제 내역</BigText>
      </TapContainer>
      <SecondContainer>
        {tab === 0 && <SubsManagement/>}
        {tab === 1 && <PaymentHistory/>}
      </SecondContainer>
    </Container>
  );
};

export default Elem;

const Container = styled.div`
  width: 430px;
  height: 700px;
  min-height: 0vh;

  display: flex;
  flex-direction: column;
`
const TapContainer = styled.div`
  width: 280px;
  height: 26px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const SecondContainer = styled.div`
  width: 100%;
  /* height: 314px; */
  margin-top: 48px;
`
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 23px;
  line-height: 26px;
  color: var(--grey);

  &.active {
    color : var(--black);
    font-weight: 700;
  }
`

const TapLine = styled.p`
height: 100%;
border-left: solid var(--dark-grey);
`
